import { Home, Star } from "@mui/icons-material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import BlockIcon from "@mui/icons-material/Block";
import CodeIcon from "@mui/icons-material/Code";

interface MenuItem {
  text: string;
  path: string;
  icon?: JSX.Element;
}

export const menuItems: MenuItem[] = [
  {
    text: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
  },
  {
    text: "Candidatos",
    path: "/candidatos",
    icon: <Home />,
  },
  {
    text: "Avaliação",
    path: "/avaliacao",
    icon: <Star />,
  },
  {
    text: "Prova Técnica",
    path: "/prova-tecnica",
    icon: <CodeIcon />,
  },
  {
    text: "Agenda",
    path: "/agenda",
    icon: <DateRangeIcon />,
  },
  {
    text: "Resultado",
    path: "/resultado",
    icon: <FactCheckIcon />,
  },
  {
    text: "Black List",
    path: "/black-list",
    icon: <BlockIcon />,
  },
  {
    text: "Importação",
    path: "/importacao",
    icon: <FileUploadOutlinedIcon />,
  },
  {
    text: "Configurações",
    path: "/configuracao",
    icon: <SettingsIcon />,
  },
];
